export default __webpack_public_path__ + "static/media/frontend_open.d5d26878.png";